/// <amd-module name="Artifacts/PackageRecycleBin/types/IDeletedPackageVersion" />

import { IPackageVersionIdentity } from "Artifacts/Root/types/IPackageVersionIdentity";

/**
 * Minimal information required for a version to be displayed, restored, and deleted
 * in the package recycle bin
 */
export interface IDeletedPackageVersion extends IPackageVersionIdentity {
  /**
   * UTC date when the package was soft deleted
   */
  deletedDate: Date;
  /**
   * UTC date after which the package will automatically be removed from the recycle bin
   * and permanently deleted.
   */
  scheduledPermanentDeleteDate: Date;
}
